import { V3Models } from "@istari/istari-client";

import type { ChatMessage, ChatRole } from "~/ai-chat/model/chat-message";

function fromChatRole(role: ChatRole): V3Models.MessageRole {
  switch (role) {
    case "user":
      return V3Models.MessageRole.User;
    case "assistant":
      return V3Models.MessageRole.Assistant;
    case "system":
      return V3Models.MessageRole.System;
    default: {
      // Exhaustive check: TS errors here if ChatRole gains a variant.
      const exhaustive: never = role;
      throw new Error(`Unknown ChatRole: ${String(exhaustive)}`);
    }
  }
}

export function fromChatMessage(message: ChatMessage): V3Models.ChatMessage {
  return {
    role: fromChatRole(message.role),
    content: message.content,
  };
}
